/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class InvoiceReportGenerationVo extends JSONable{
  fromBankAccount: string | undefined = undefined;
  toBankAccountListSummary: string | undefined = undefined;
  amountToPay: number | undefined = undefined;
  currencyCode: string | undefined = undefined;
  serviceProviderName: string | undefined = undefined
  invoiceSeries: string | undefined = undefined;
  lineCount?: number;
}
